import apiService from './api';
import { API_ENDPOINTS } from '../utils/apiUrls';

const normalizeProgram = (raw) => {
  if (!raw) return null;

  // Directus proxy responds with { data: [...] } or { data: {...} }
  const payload = raw.data ?? raw;
  const first = Array.isArray(payload) ? payload[0] : payload;
  if (!first) return null;
  const item = first.friend_referrals ?? first;

  const mapReward = (row = {}) => ({
    min_deposit: row.MinDeposit ?? row.min_deposit ?? null,
    max_deposit: row.MaxDeposit ?? row.max_deposit ?? null,
    total_pct: row.TotalPct ?? row.total_pct ?? null,
    you_pct: row.YouPct ?? row.you_pct ?? null,
    friend_pct: row.FriendPct ?? row.friend_pct ?? null,
  });

  const mapBand = (band = {}) => ({
    code: band.Code ?? band.code ?? '',
    title: band.Title ?? band.title ?? '',
    min_approved: band.MinApproved ?? band.min_approved ?? 0,
    description: band.Description ?? band.description ?? '',
    rewards: (band.Rewards ?? band.rewards ?? []).map(mapReward),
    extras: band.Extras ?? band.extras ?? [],
  });

  const mapLot = (row = {}) => ({
    min_deposit: row.MinDeposit ?? row.min_deposit ?? null,
    max_deposit: row.MaxDeposit ?? row.max_deposit ?? null,
    lots: row.Lots ?? row.lots ?? null,
  });

  const mapFaq = (row = {}) => ({
    question: row.Question ?? row.question ?? '',
    answer: row.Answer ?? row.answer ?? '',
  });

  return {
    hero_title: item.HeroTitle ?? item.hero_title ?? '',
    hero_subtitle: item.HeroSubtitle ?? item.hero_subtitle ?? '',
    cta: item.CTA ?? item.cta ?? {},
    bands: (item.Bands ?? item.bands ?? []).map(mapBand),
    lot_requirements: (item.LotRequirements ?? item.lot_requirements ?? []).map(mapLot),
    faqs: (item.FAQs ?? item.faqs ?? []).map(mapFaq),
    rules: item.Rules ?? item.rules ?? [],
    updated_at: item.UpdatedAt ?? item.updated_at ?? null,
  };
};

export const fetchReferralProgram = async () => {
  const res = await apiService.get(API_ENDPOINTS.REFERRALS.PROGRAM, { limit: 1 });
  return normalizeProgram(res);
};

export const fetchReferralOverview = async (params = {}) => {
  return apiService.get(API_ENDPOINTS.REFERRALS.OVERVIEW, params);
};

export const createReferral = async (payload) => {
  return apiService.post(API_ENDPOINTS.REFERRALS.CREATE, payload);
};

const referralApi = {
  fetchReferralProgram,
  fetchReferralOverview,
  createReferral,
};

export default referralApi;
